
const environment = {
    END_POINT: {
        BASE: process.env.REACT_APP_API_BASE_URL
    },

    GOOGLE: {
        MAP_API: process.env.REACT_APP_GOOGLE_MAP_KEY
    }
}

export default environment
